import {
    Accordion,
    styled,
    Text,
    TextTag,
    TokenTextAppearance,
} from '@volkswagen-onehub/components-core'
import {useTranslation} from 'react-i18next'
import React, {useState} from 'react'

interface FaqAccordionProps {
    title: string
    text: string
    index: number
}

const FaqAccordionContainer = styled.div`
    * {
        word-break: normal;
    }
`

export function FaqAccordion(props: FaqAccordionProps): React.JSX.Element {
    const {t} = useTranslation('fa-flotte')
    const [openIndex, setOpenIndex] = useState(-1)

    return (
        <FaqAccordionContainer>
            <Accordion
                id={String(props.index)}
                headline={
                    <Text
                        tag={TextTag.p}
                        appearance={TokenTextAppearance.bigcopy200}
                        bold
                    >
                        <span>{props.index + 1}. </span>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: t(props.title),
                            }}
                        />
                    </Text>
                }
                onClick={() => {
                    if (props.index === openIndex) {
                        setOpenIndex(-1)
                    } else {
                        setOpenIndex(props.index)
                    }
                }}
                isOpen={props.index === openIndex}
            >
                {props.text && (
                    <Text
                        tag={TextTag.p}
                        appearance={TokenTextAppearance.copy200}
                    >
                        <span
                            dangerouslySetInnerHTML={{
                                __html: t(props.text),
                            }}
                        />
                    </Text>
                )}
            </Accordion>
        </FaqAccordionContainer>
    )
}
